import PropTypes from 'prop-types';

const I18nType = PropTypes.shape({
  _translate: PropTypes.func,
  _t: PropTypes.func,
  _abbreviation: PropTypes.func,
  _abbr: PropTypes.func,
});

export default I18nType;
